import React, { useState } from "react";
import "./BusinessFibre.css";

export default function BusinessFibre(): JSX.Element {
  const [openKey, setOpenKey] = useState<string | null>(null);
  const toggle = (key: string) => setOpenKey(prev => (prev === key ? null : key));

  /* --- Fibre Plans (Standard vs Premium Comparison) --- */
  const speeds = [
    { speed: "250 Mbps", standard: "$399.00", premium: "$599.00", contract: "48 months", activation: "-" },
    { speed: "400 Mbps", standard: "$449.00", premium: "$599.00", contract: "48 months", activation: "-" },
    { speed: "500 Mbps", standard: "$499.00", premium: "$899.00", contract: "48 months", activation: "-" },
    { speed: "1 Gbps", standard: "$749.00", premium: "$1,199.00", contract: "48 months", activation: "-" },
    { speed: "2 Gbps", standard: "$1,149.00", premium: "$1,799.00", contract: "48 months", activation: "-" },
    { speed: "5 Gbps", standard: "POA", premium: "POA", contract: "48 months", activation: "-" },
    { speed: "10 Gbps", standard: "POA", premium: "POA", contract: "48 months", activation: "-" }
  ];

  return (
    <>
      {/* =============================================== */}
      {/*          FULL-WIDTH BLUE HERO BANNER            */}
      {/* =============================================== */}
      <section className="bf-hero">
        <h1>J-Data Fibre</h1>
        <p>
          Enterprise-grade fibre connectivity from 250 Mbps to 10 Gbps with premium SLAs,
          IPv4 options and business-grade support.
        </p>
      </section>

      {/* =============================================== */}
      {/*                MAIN PAGE CONTENT                */}
      {/* =============================================== */}
      <main className="bf-page">

        {/* PLAN COMPARISON TABLE – TELSTRA STYLE */}
        <section className="bf-section">
          <h2>J-Data Fibre Plans</h2>

          <div className="bf-table-compare">
            <table>
              <thead>
                <tr>
                  <th>Speed</th>
                  <th>
                    Standard<br />
                    <span className="sla-label">12-Hour SLA</span>
                  </th>
                  <th>
                    Premium<br />
                    <span className="sla-label">4-Hour SLA</span>
                  </th>
                </tr>
              </thead>

              <tbody>
                {speeds.map((item, i) => (
                  <tr key={i}>
                    <td className="speed-label">{item.speed}</td>
                    <td>
                      <span className="from-label">from</span>
                      <div className="price">{item.standard}</div>
                    </td>
                    <td>
                      <span className="from-label">from</span>
                      <div className="price">{item.premium}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* IPv4 OPTIONS */}
        <section className="bf-section">
          <h2>IPv4 Address Options</h2>

          <div className="bf-table">
            <table>
              <thead>
                <tr>
                  <th>IPv4 Address Option</th>
                  <th>From Price inc. GST / Month</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>/32 – 1 static IP</td><td>$5.00</td></tr>
                <tr><td>/31 – 2 static IPs</td><td>$9.00</td></tr>
                <tr><td>/30 – 4 static IPs</td><td>$19.00</td></tr>
                <tr><td>/29 – 8 static IPs</td><td>$49.00</td></tr>
                <tr><td>/28 – 16 static IPs</td><td>$99.00</td></tr>
                <tr><td>/27 – 32 static IPs</td><td>$199.00</td></tr>
                <tr><td>/26 – 64 static IPs</td><td>$399.00</td></tr>
                <tr><td>/25 – 128 static IPs</td><td>$699.00</td></tr>
                <tr><td>/24 – 256 static IPs</td><td>$999.00</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* SLA TABLE */}
        <section className="bf-section">
          <h2>Service Level Agreements (SLA)</h2>

          <div className="bf-table">
            <table>
              <thead>
                <tr>
                  <th>Access Class</th>
                  <th>From Price inc. GST / Month</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Standard – Business</td><td>-</td></tr>
                <tr><td>Standard – Business Plus</td><td>$149.00</td></tr>
                <tr><td>Premium – Business Plus</td><td>-</td></tr>
                <tr><td>Premium – Express8</td><td>$149.00</td></tr>
                <tr><td>Premium – Express4</td><td>$359.00</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        

        {/* CTA PANEL */}
        <section className="bf-cta">
          <div className="bf-cta-content">
            <h2>Ready to Talk Business Fibre?</h2>
            <p>
              Speak with our team on{" "}
              <a href="tel:1300567835" className="bf-cta-phone">1300 567 835</a>{" "}
              or send us your requirements for a tailored quote.
            </p>
          </div>

          <div className="bf-cta-actions">
            <a href="tel:1300567835" className="bf-cta-btn primary">Call 1300 567 835</a>
            <a href="/contact" className="bf-cta-btn secondary">Request a Business Fibre Quote</a>
          </div>
        </section>

        {/* ACCORDIONS */}
        <section className="bf-section bf-bottom-info">
          <h2>Additional Information</h2>

          {/* ETF */}
          <div className={`bf-accordion-item ${openKey === "etf" ? "open" : ""}`}>
            <button className="bf-accordion-header" onClick={() => toggle("etf")}>
              <span>Early Termination Fees</span>
              <span className="chevron">{openKey === "etf" ? "−" : "+"}</span>
            </button>
            <div className="bf-accordion-body">
              <div className="bf-table">
                <table>
                  <thead>
                    <tr>
                      <th>Scenario</th>
                      <th>Early Termination Fee</th>
                      <th>From Price inc. GST Once-Off</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td>Order receipt, but pre-order acceptance</td><td>-</td><td>-</td></tr>
                    <tr><td>After Telstra has accepted order before handover</td><td>-</td><td>$2,574.00</td></tr>
                    <tr><td>After installation but before handover</td><td>-</td><td>$4,719.00</td></tr>
                    <tr><td>After service tested but before handover</td><td>-</td><td>$8,151.00</td></tr>
                    <tr>
                      <td>After handover but before first 12 months</td>
                      <td>
                        <ul>
                          <li>$8,580.00 +</li>
                          <li>100% remaining minimum monthly rental +</li>
                          <li>30% remaining fixed-term charges</li>
                        </ul>
                      </td>
                      <td>Varies</td>
                    </tr>
                    <tr>
                      <td>After first 12 months but before end of term</td>
                      <td>
                        <ul>
                          <li>$8,580.00 +</li>
                          <li>30% remaining recurring charges</li>
                        </ul>
                      </td>
                      <td>Varies</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* CALL OUT */}
          <div className={`bf-accordion-item ${openKey === "callout" ? "open" : ""}`}>
            <button className="bf-accordion-header" onClick={() => toggle("callout")}>
              <span>Call-Out Charges</span>
              <span className="chevron">{openKey === "callout" ? "−" : "+"}</span>
            </button>

            <div className="bf-accordion-body">
              <div className="bf-box">
                <ul>
                  <li>Incorrect call-out where technician attends.</li>
                  <li>Missed appointment time with technician.</li>
                  <li>Responding outside coverage hours per request.</li>
                  <li>Installation/maintenance for extra components.</li>
                  <li>Customer-requested work not covered.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* MODIFICATION */}
          <div className={`bf-accordion-item ${openKey === "modification" ? "open" : ""}`}>
            <button className="bf-accordion-header" onClick={() => toggle("modification")}>
              <span>Service Modification Charge</span>
              <span className="chevron">{openKey === "modification" ? "−" : "+"}</span>
            </button>

            <div className="bf-accordion-body">
              <div className="bf-box">
                <p><strong>Service modification charge:</strong> $429.00 per service.</p>
              </div>
            </div>
          </div>

          {/* NOTES */}
          <div className={`bf-accordion-item ${openKey === "notes" ? "open" : ""}`}>
            <button className="bf-accordion-header" onClick={() => toggle("notes")}>
              <span>Notes</span>
              <span className="chevron">{openKey === "notes" ? "−" : "+"}</span>
            </button>

            <div className="bf-accordion-body">
              <div className="bf-box">
                <ol>
                  <li>Prices include GST.</li>
                  <li>Service qualification required.</li>
                  <li>ETF applies to remaining contract value.</li>
                  <li>Modification charges subject to POA.</li>
                  <li>Call-out charges based on infrastructure owner fees.</li>
                  <li>J Data – Fibre includes public Layer 3 access.</li>
                  <li>Does not cover multi-site orders.</li>
                  <li>Relocations not available — new service required.</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

      </main>
    </>
  );
}
